import { render, staticRenderFns } from "./BaseInformationStep.vue?vue&type=template&id=51e16f66&"
import script from "./BaseInformationStep.vue?vue&type=script&lang=ts&"
export * from "./BaseInformationStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports